export default __webpack_public_path__ + "static/media/firstOne.18371824.png";